import { render, staticRenderFns } from "./EditShareholder.vue?vue&type=template&id=9969a3ce&"
import script from "./EditShareholder.vue?vue&type=script&lang=js&"
export * from "./EditShareholder.vue?vue&type=script&lang=js&"
import style0 from "./EditShareholder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports